import { Stack, Text } from '@ltvco/refresh-lib/theme';
import { Edit } from '@mui/icons-material';
import { useState } from 'react';

import {
  StyledDesktopLayout,
  StyledLoginInformationContainer,
  StyledLoginInformationTitle,
  StyledMobileLayout,
  StyledPasswordRow,
  StyledUpdatePasswordButton,
} from './components';
import { UpdatePasswordModal } from './UpdatePasswordModal';

const MASKED_PASSWORD = '••••••••••••••••';

export const LoginInformation = () => {
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] =
    useState(false);

  const handleUpdatePasswordClick = () => {
    setIsChangePasswordModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsChangePasswordModalOpen(false);
  };

  const passwordRow = (
    <StyledPasswordRow>
      <Text variant="body2" color="text.primary">
        Password
      </Text>
      <Text variant="body2" color="text.primary">
        {MASKED_PASSWORD}
      </Text>
    </StyledPasswordRow>
  );

  const updateButton = (
    <StyledUpdatePasswordButton
      variant="contained"
      color="primary"
      startIcon={<Edit sx={{ fontSize: '16px !important' }} />}
      onClick={handleUpdatePasswordClick}
    >
      Update Password
    </StyledUpdatePasswordButton>
  );

  return (
    <>
      <StyledLoginInformationContainer>
        <StyledDesktopLayout>
          <StyledLoginInformationTitle variant="h3">
            Login Information
          </StyledLoginInformationTitle>
          {updateButton}
        </StyledDesktopLayout>
        <StyledMobileLayout>
          <StyledLoginInformationTitle variant="h3">
            Login Information
          </StyledLoginInformationTitle>
          {passwordRow}
          {updateButton}
        </StyledMobileLayout>
        <Stack sx={{ display: { xs: 'none', md: 'flex' } }}>
          {passwordRow}
        </Stack>
      </StyledLoginInformationContainer>

      <UpdatePasswordModal
        isOpen={isChangePasswordModalOpen}
        onClose={handleCloseModal}
        onSuccess={handleCloseModal}
      />
    </>
  );
};
